import * as React from 'react';
import { Box, Image, Button, Collapse, useDisclosure, useBreakpointValue } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/pro-regular-svg-icons';

interface Props {
  url: string | any;
  altText: string;
}

const UploadExample: React.FC<Props> = (props: Props) => {
  const isMDScreen = useBreakpointValue({ base: false, md: true });

  const { onToggle, isOpen } = useDisclosure();
  // @ts-ignore
  const ExampleImage = () => <Image src={props.url} alt={props.altText} />;

  return (
    <>
      {isMDScreen ? (
        <ExampleImage />
      ) : (
        <Box borderWidth={1} p={2} borderRadius="lg">
          <Button
            onClick={onToggle}
            leftIcon={<FontAwesomeIcon icon={isOpen ? faChevronUp : faChevronDown} className="utility-icon" />}
            variant="ghost"
            size="sm"
            width="100%"
            borderRadius="base"
          >
            {isOpen ? 'Hide' : 'Show'} example document
          </Button>

          <Collapse in={isOpen} animateOpacity>
            <ExampleImage />
          </Collapse>
        </Box>
      )}
    </>
  );
};

export default React.memo(UploadExample);
